module.exports = __webpack_public_path__ + "img/logo.363e8785.png";